webpackJsonp([153],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorHandler;
/* harmony export (immutable) */ __webpack_exports__["c"] = isUpdatedComponent;
/* harmony export (immutable) */ __webpack_exports__["d"] = migrateComponents;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFontawesomeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(26);





/**
 * axiosでの共通エラーハンドリング
 */
function errorHandler(error) {
  if (error.response) {
    console.log('error.response:');
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log('error.request:');
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  console.log('error.config:');
  console.log(error.config);

  if (error.response) {
    return {
      error: error,
      status: error.response.status,
      statusText: error.response.statusText,
      code: error.response.data.code,
      message: error.response.data.message
    };
  } else if (~error.message.indexOf('timeout')) {
    return {
      error: error,
      status: 408,
      statusText: 'リクエストタイムアウト',
      code: 'Request timeout',
      message: 'リクエストが一定時間以内に完了しませんでした。ネットワークの状態がいい場所で再読み込みしてください。'
    };
  } else if (error.request) {
    return {
      error: error,
      status: 404,
      statusText: 'リソースが見つかりませんでした',
      code: 'Not found',
      message: 'リソースが見つかりませんでした。'
    };
  } else {
    return { error: error, status: 'Request error', message: error.message };
  }
}

/**
 * コンポーネントが最新の状態かどうかをチェックする関数
 */
function isUpdatedComponent(component) {
  var matched = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[component.id];
  if (!matched) return false;
  if (component.meta === undefined) return false;
  if (component.meta.file !== matched.meta.file) return false;
  if (component.meta.name !== matched.meta.name) return false;
  if (component.meta.type !== matched.meta.type) return false;
  if (component.meta.title !== matched.meta.title) return false;
  if (component.meta.description !== matched.meta.description) return false;
  return true;
}

/**
 * 各コンポーネントのcontentsが最新の状態かどうかを調べ、そうでなければ
 * デフォルト値を追加する
 */
function migrateComponents(components) {
  return Array.isArray(components) ? components.map(function (component) {
    var matched = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].components[component.id];
    if (!matched) return false;
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(matched.contents).forEach(function (key) {
      if (component.contents[key] === void 0) {
        if (Array.isArray(component.contents[key])) {
          component.contents[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(matched.contents[key]));
        } else {
          component.contents[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matched.contents[key]);
        }
      }
    });
    return component;
  }) : components;
}

function getFontawesomeIcons() {
  return [{ value: 'address-card-o' }, { value: 'book' }, { value: 'bookmark' }, { value: 'bookmark-o' }, { value: 'briefcase' }, { value: 'building' }, { value: 'building-o' }, { value: 'calculator' }, { value: 'calendar' }, { value: 'calendar-check-o' }, { value: 'calendar-minus-o' }, { value: 'calendar-o' }, { value: 'calendar-plus-o' }, { value: 'calendar-times-o' }, { value: 'camera' }, { value: 'cloud' }, { value: 'coffee' }, { value: 'comment' }, { value: 'comment-o' }, { value: 'commenting' }, { value: 'commenting-o' }, { value: 'comments' }, { value: 'comments-o' }, { value: 'credit-card' }, { value: 'credit-card-alt' }, { value: 'cutlery' }, { value: 'desktop' }, { value: 'envelope' }, { value: 'envelope-o' }, { value: 'envelope-open' }, { value: 'envelope-open-o' }, { value: 'exclamation-circle' }, { value: 'exclamation-triangle' }, { value: 'eye' }, { value: 'female' }, { value: 'gift' }, { value: 'globe' }, { value: 'id-card' }, { value: 'id-card-o' }, { value: 'info' }, { value: 'info-circle' }, { value: 'laptop' }, { value: 'location-arrow' }, { value: 'male' }, { value: 'map' }, { value: 'map-marker' }, { value: 'mobile' }, { value: 'phone' }, { value: 'question-circle' }, { value: 'question-circle-o' }, { value: 'road' }, { value: 'street-view' }, { value: 'suitcase' }, { value: 'tachometer' }, { value: 'tag' }, { value: 'tags' }, { value: 'television' }, { value: 'thumbs-up' }, { value: 'thumbs-o-up' }, { value: 'umbrella' }, { value: 'user' }, { value: 'user-circle' }, { value: 'user-circle-o' }, { value: 'user-o' }, { value: 'users' }, { value: 'ambulance' }, { value: 'bicycle' }, { value: 'bus' }, { value: 'car' }, { value: 'motorcycle' }, { value: 'plane' }, { value: 'subway' }, { value: 'taxi' }, { value: 'train' }, { value: 'truck' }, { value: 'wheelchair' }, { value: 'wheelchair-alt' }, { value: 'area-chart' }, { value: 'bar-chart' }, { value: 'line-chart' }, { value: 'pie-chart' }, { value: 'yen' }, { value: 'hand-o-up' }, { value: 'hand-o-left' }, { value: 'hand-o-right' }, { value: 'hand-o-down' }, { value: 'facebook' }, { value: 'facebook-official' }, { value: 'facebook-square' }, { value: 'google' }, { value: 'google-plus' }, { value: 'google-plus-official' }, { value: 'wordpress' }, { value: 'youtube' }, { value: 'youtube-play'
    // // {value: 'accessible-icon'},
    // {value: 'address-book'},
    // {value: 'address-card'},
    // {value: 'ambulance'},
    // // {value: 'app-store'},
    // {value: 'apple'},
    // {value: 'archive'},
    // {value: 'at'},
    // {value: 'barcode'},
    // {value: 'bicycle'},
    // {value: 'blind'},
    // {value: 'bluetooth-b'},
    // {value: 'bolt'},
    // {value: 'book'},
    // {value: 'bookmark'},
    // {value: 'briefcase'},
    // {value: 'building'},
    // {value: 'bus'},
    // {value: 'calculator'},
    // {value: 'calendar'},
    // // {value: 'calendar-alt'},
    // // {value: 'calendar-check'},
    // // {value: 'calendar-minus'},
    // // {value: 'calendar-plus'},
    // // {value: 'calendar-times'},
    // {value: 'camera'},
    // {value: 'camera-retro'},
    // {value: 'car'},
    // // {value: 'chart-area'},
    // // {value: 'chart-bar'},
    // // {value: 'chart-line'},
    // // {value: 'chart-pie'},
    // {value: 'check'},
    // {value: 'child'},
    // {value: 'clipboard'},
    // // {value: 'clock'},
    // {value: 'clone'},
    // {value: 'cloud'},
    // {value: 'coffee'},
    // {value: 'cog'},
    // {value: 'comment'},
    // // {value: 'comment-alt'},
    // {value: 'comments'},
    // {value: 'copy'},
    // {value: 'credit-card'},
    // {value: 'desktop'},
    // {value: 'edit'},
    // {value: 'envelope'},
    // {value: 'envelope-open'},
    // {value: 'exclamation'},
    // // {value: 'exclamation-cicle'},
    // {value: 'exclamation-triangle'},
    // // {value: 'facebook-messenger'},
    // {value: 'facebook-square'},
    // {value: 'female'},
    // // {value: 'flight-jet'},
    // {value: 'file'},
    // {value: 'gift'},
    // {value: 'globe'},
    // {value: 'google'},
    // {value: 'google-plus'},
    // // {value: 'hand-paper'},
    // // {value: 'hand-point-right'},
    // // {value: 'handshake'},
    // {value: 'heart'},
    // {value: 'home'},
    // {value: 'id-badge'},
    // {value: 'id-card'},
    // {value: 'image'},
    // // {value: 'images'},
    // {value: 'info-circle'},
    // {value: 'instagram'},
    // {value: 'key'},
    // {value: 'life-ring'},
    // // {value: 'line'},
    // {value: 'link'},
    // {value: 'list'},
    // {value: 'list-alt'},
    // {value: 'list-ol'},
    // {value: 'list-ul'},
    // {value: 'location-arrow'},
    // {value: 'lock'},
    // // {value: 'lock-open'},
    // {value: 'male'},
    // {value: 'map'},
    // // {value: 'map-marker'},
    // // {value: 'map-marker-alt'},
    // {value: 'map-pin'},
    // {value: 'microphone'},
    // {value: 'microphone-slash'},
    // {value: 'mobile'},
    // // {value: 'mobile-alt'},
    // {value: 'motorcycle'},
    // {value: 'paperclip'},
    // {value: 'phone'},
    // {value: 'plane'},
    // {value: 'print'},
    // {value: 'question'},
    // // {value: 'question-cicle'},
    // {value: 'search'},
    // {value: 'search-minus'},
    // {value: 'search-plus'},
    // {value: 'server'},
    // // {value: 'shield-alt'},
    // {value: 'star'},
    // {value: 'sticky-note'},
    // {value: 'street-view'},
    // {value: 'subway'},
    // {value: 'sync'},
    // // {value: 'sync-alt'},
    // // {value: 'tablet-alt'},
    // // {value: 'tachometer-alt'},
    // {value: 'tag'},
    // {value: 'tags'},
    // {value: 'tasks'},
    // {value: 'taxi'},
    // {value: 'truck'},
    // {value: 'user'},
    // // {value: 'user-cicle'},
    // {value: 'users'},
    // // {value: 'utensil-spoon'},
    // // {value: 'utensils'},
    // // {value: 'video'},
    // {value: 'wheelchair'},
    // {value: 'windows'},
    // {value: 'wordpress'},
    // // {value: 'yen-sign'},
    // {value: 'youtube'},
    // {value: 'youtube-square'}
  }];
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  errorHandler: errorHandler,
  isUpdatedComponent: isUpdatedComponent,
  migrateComponents: migrateComponents,
  getFontawesomeIcons: getFontawesomeIcons
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(56);

/**
 * WordPress API
 */



// Add a request interceptor
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  config.timeout = 10000;
  config.baseURL = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['wordpress/account/url'];
  if (!config.headers) config.headers = {};
  if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json';
  if (config.url !== '/wp-json/jwt-auth/v1/token') config.headers['Authorization'] = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['wordpress/account/authorizationHeader'];
  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * WP REST APIにアクセスするためのJWTを取得
   *
   * POST /wp-json/jwt-auth/v1/token
   */
  getToken: function getToken(_ref) {
    var username = _ref.username,
        password = _ref.password;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/jwt-auth/v1/token', { username: username, password: password });
  },


  /**
   * ユーザー一覧を取得
   *
   * GET /wp-json/wp/v2/users
   */
  getUsers: function getUsers() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/users');
  },


  /**
   * 投稿ページ一覧の取得
   *
   * GET /wp-json/wp/v2/posts
   */
  getPosts: function getPosts() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/posts', {
      params: {
        status: 'publish,draft,private',
        order: 'desc',
        per_page: 100
      }
    });
  },


  /**
   * 新規投稿の作成
   *
   * POST /wp-json/wp/v2/posts
   */
  createPost: function createPost(data, config) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/posts', data, config);
  },


  /**
   * 投稿の更新
   *
   * POST /wp-json/wp/v2/posts/{id}
   */
  updatePost: function updatePost(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/posts/' + id, data);
  },


  /**
   * 投稿の削除
   *
   * DELETE /wp-json/wp/v2/posts/{id}
   */
  deletePost: function deletePost(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/wp-json/wp/v2/posts/' + id, { data: { force: true } });
  },


  /**
   * 固定ページ一覧の取得
   *
   * GET /wp-json/wp/v2/pages
   */
  getPages: function getPages() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/pages', {
      params: {
        status: 'publish,draft,private',
        order: 'asc',
        orderby: 'menu_order',
        per_page: 100
      }
    });
  },


  /**
   * 新規固定ページの作成
   *
   * POST /wp-json/wp/v2/pages
   */
  createPage: function createPage(data, config) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/pages', data, config);
  },


  /**
   * 固定ページの更新
   *
   * POST /wp-json/wp/v2/pages/{id}
   */
  updatePage: function updatePage(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/pages/' + id, data);
  },


  /**
   * 固定ページの削除
   *
   * DELETE /wp-json/wp/v2/pages/{id}
   */
  deletePage: function deletePage(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/wp-json/wp/v2/pages/' + id, { data: { force: true } });
  },


  /**
   * メディア一覧の取得
   *
   * GET /wp-json/wp/v2/media
   */
  getMedia: function getMedia() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/wp/v2/media', {
      params: { per_page: 100 }
    });
  },


  /**
   * 新規メディアの作成
   *
   * POST /wp-json/wp/v2/media
   */
  createMedia: function createMedia(data, config) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/media', data, config);
  },


  /**
   * メディアの更新
   *
   * POST /wp-json/wp/v2/media/{id}
   */
  updateMedia: function updateMedia(id, data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/wp/v2/media/' + id, data);
  },


  /**
   * メディアの削除
   *
   * DELETE /wp-json/wp/v2/media/{id}
   */
  deleteMedia: function deleteMedia(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/wp-json/wp/v2/media/' + id, { data: { force: true } });
  },


  /**
   * テーマ情報の取得
   *
   * GET /wp-json/evsma-press/v1/themes
   */
  getThemes: function getThemes() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/evsma-press/v1/themes');
  },


  /**
   * テーマ情報の更新
   *
   * POST /wp-json/evsma-press/v1/themes
   */
  updateThemes: function updateThemes(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/evsma-press/v1/themes', data);
  },


  /**
   * 設定情報の取得
   *
   * GET /wp-json/evsma-press/v1/settings
   */
  getSettings: function getSettings() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/wp-json/evsma-press/v1/settings');
  },


  /**
   * 設定情報の更新
   *
   * POST /wp-json/evsma-press/v1/settings
   */
  updateSettings: function updateSettings(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/wp-json/evsma-press/v1/settings', data);
  }
});

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_components_json__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_components_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__app_components_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_templates_json__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_templates_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__app_templates_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_colors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__app_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_settings_json__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_settings_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__app_settings_json__);


/**
 * App API
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * App componentsを、IDをキーとしたオブジェクトとして返す
   */
  components: __WEBPACK_IMPORTED_MODULE_2__app_components_json___default.a.reduce(function (p, c) {
    p[c.id] = c;return p;
  }, {}),

  /**
   * App componentsを配列として返す
   */
  componentsArray: __WEBPACK_IMPORTED_MODULE_2__app_components_json___default.a,

  /**
   * 引数に指定されているtypeをもつcomponentを配列として返す
   *
   * @param string type
   */
  componentsArrayOfType: function componentsArrayOfType(type) {
    return __WEBPACK_IMPORTED_MODULE_2__app_components_json___default.a.filter(function (component) {
      return component.meta.type === type;
    });
  },


  /**
   * App templatesを、IDをキーとしたオブジェクトとして返す
   */
  templates: __WEBPACK_IMPORTED_MODULE_3__app_templates_json___default.a.map(function (template) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, template.id, template);
  }),

  /**
   * App templatesを配列として返す
   */
  templatesArray: __WEBPACK_IMPORTED_MODULE_3__app_templates_json___default.a,

  /**
   * App colorsをオブジェクトとして返す
   */
  colors: __WEBPACK_IMPORTED_MODULE_4__app_colors_json___default.a,

  /**
   * App settingsをオブジェクトとして返す
   */
  settings: __WEBPACK_IMPORTED_MODULE_5__app_settings_json___default.a,

  /**
   * App settingsのプロパティを配列として返す
   */
  settingsProps: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__app_settings_json___default.a),

  /**
   * App settingsから設定情報だけを抜き出してオブジェクトとして返す
   */
  settingsDefault: getSettingsFromTemplate(__WEBPACK_IMPORTED_MODULE_5__app_settings_json___default.a)
});

function getSettingsFromTemplate(template) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(template).reduce(function (prev, curr) {
    prev[curr] = recursiveReduce(template[curr]);
    return prev;
  }, {});
}

function recursiveReduce(template) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(template).reduce(function (prev, curr) {
    if (curr === 'meta') return prev;
    switch (template[curr].type) {
      case 'text':
        prev[curr] = template[curr].default || '';
        break;
      case 'number':
        prev[curr] = template[curr].default || 0;
        break;
      case 'checkbox':
        prev[curr] = template[curr].values.map(function (elm) {
          return elm.default;
        });
        break;
      default:
        prev[curr] = recursiveReduce(template[curr]);
        break;
    }
    return prev;
  }, {});
}

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpSidebar_vue__ = __webpack_require__(118);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4ad6878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpSidebar_vue__ = __webpack_require__(276);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4ad6878"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4ad6878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(56);



var _this = this;





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

function loadRoute(component) {
  return function () {
    return __webpack_require__(271)("./" + component + '.vue');
  };
}

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  // export default new Router({
  mode: 'history',
  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */
  routes: [{
    path: '/',
    name: 'home',
    ja: 'ホーム',
    component: loadRoute('Home'),
    icon: 'home',
    color: '#BF4A67'

  }, {
    path: '/admin',
    name: 'admin',
    ja: '管理者専用',
    meta: { requiresAuth: true },
    component: loadRoute('Admin')
  }, {
    path: '/posts',
    name: 'posts',
    ja: '投稿一覧',
    component: loadRoute('Posts'),
    meta: { requiresAuth: true },
    icon: 'edit',
    color: '#178CA6'
  }, {
    path: '/posts/:id(\\d+)',
    name: 'post',
    ja: '投稿編集',
    component: loadRoute('Post'),
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/pages',
    name: 'pages',
    ja: '固定ページ一覧',
    component: loadRoute('Pages'),
    meta: { requiresAuth: true },
    icon: 'files-o',
    color: '#368F7D'
  }, {
    path: '/pages/create',
    name: 'pages-create',
    ja: '固定ページ作成',
    component: loadRoute('PagesCreate'),
    meta: { requiresAuth: true }
  }, {
    path: '/pages/:id(\\d+)',
    name: 'page',
    ja: '固定ページ編集',
    component: loadRoute('Page'),
    props: true,
    meta: { requiresAuth: true }
  }, {
    path: '/media',
    name: 'media',
    ja: 'アップロード画像',
    component: loadRoute('Media'),
    meta: { requiresAuth: true },
    icon: 'image',
    color: '#EE7469'
  }, {
    path: '/media/upload',
    name: 'media-upload',
    ja: '画像アップロード',
    component: loadRoute('MediaUpload'),
    meta: { requiresAuth: true }
  }, {
    path: '/themes',
    name: 'themes',
    ja: 'サイトテーマ',
    component: loadRoute('Themes'),
    meta: { requiresAuth: true },
    icon: 'columns',
    // color: '#00587A'
    color: '#4c8aa1'
  }, {
    path: '/settings',
    name: 'settings',
    ja: 'サイト設定',
    component: loadRoute('Settings'),
    meta: { requiresAuth: true },
    icon: 'gear',
    color: '#44B39D'
  }, {
    path: '*',
    redirect: '/'
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var isLoggedIn;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // /**
            //  * ページを表示する前にsettingsを取得しておく
            //  */
            // // if (to.matched.some(record => ~['page', 'settings', 'themes'].indexOf(record.name))) {
            // if (~['page', 'themes', 'settings'].indexOf(to.name)) {
            //   if (process.env.NODE_ENV !== 'production') console.log('Get settings before entering route...')
            //   await store.dispatch('wordpress/getSettings')
            // }
            //
            // /**
            //  * ページを表示する前にthemesを取得しておく
            //  */
            // // if (to.matched.some(record => ~['page', 'themes'].indexOf(record.name))) {
            // if (~['page', 'themes'].indexOf(to.name)) {
            //   if (process.env.NODE_ENV !== 'production') console.log('Get themes before entering route...')
            //   await store.dispatch('wordpress/getThemes')
            // }
            //
            // /**
            //  * ページを表示する前にpagesを取得しておく
            //  */
            // // if (to.matched.some(record => ~['pages', 'pages-tree'].indexOf(record.name))) {
            // if (~['pages', 'page', 'themes'].indexOf(to.name)) {
            //   if (process.env.NODE_ENV !== 'production') console.log('Get pages before entering route...')
            //   if (!store.getters['wordpress/pages'].length) await store.dispatch('wordpress/getPages')
            // }
            //
            // /**
            //  * ページを表示する前にmediaを取得しておく
            //  */
            // // if (to.matched.some(record => ~['settings', 'images'].indexOf(record.name))) {
            // if (~['images', 'page', 'themes', 'settings'].indexOf(to.name)) {
            //   if (process.env.NODE_ENV !== 'production') console.log('Get media before entering route...')
            //   if (!store.getters['wordpress/media'].length) await store.dispatch('wordpress/getMedia')
            // }

            isLoggedIn = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['wordpress/account/isLoggedIn'];

            if (to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              if (!isLoggedIn) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('wordpress/account/logout');
                next({ path: '/', query: { redirect: to.fullPath } });
              } else {
                next();
              }
            } else {
              next();
            }

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(117);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002f1f24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-002f1f24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002f1f24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDashboard_vue__ = __webpack_require__(85);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcc4218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDashboard_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dcc4218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcc4218_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidemenu_vue__ = __webpack_require__(86);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e49f207e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidemenu_vue__ = __webpack_require__(277);
function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e49f207e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidemenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e49f207e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidemenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_wordpress__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_logger__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/**
 * Plugins for WordPress module
 */
var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    if (mutation.type === 'wordpress/account/url') localStorage.setItem('url', state.wordpress.account.url);
    if (mutation.type === 'wordpress/account/username') localStorage.setItem('username', state.wordpress.account.username);
    if (mutation.type === 'wordpress/account/password') localStorage.setItem('password', state.wordpress.account.password);

    if (mutation.type === 'wordpress/account/login') {
      localStorage.setItem('token', state.wordpress.account.token);
      localStorage.setItem('email', state.wordpress.account.email);
    }

    if (mutation.type === 'wordpress/account/getId') {
      localStorage.setItem('id', state.wordpress.account.id);
    }

    // ログアウト時にストレージのtoken等を破棄する
    if (mutation.type === 'wordpress/account/logout') {
      localStorage.removeItem('jwt');
      localStorage.removeItem('id');
      localStorage.removeItem('email');
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  namespaced: true,
  plugins:  false ? [createLogger(), localStoragePlugin] : [localStoragePlugin],
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    wordpress: __WEBPACK_IMPORTED_MODULE_3__modules_wordpress__["a" /* default */],
    strict: "production" !== 'production'
  }
}));

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__(119);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f42177f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__(279);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f42177f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f42177f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppDashboard__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_routes_Login__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'login': __WEBPACK_IMPORTED_MODULE_1__components_routes_Login__["default"],
    'dashboard': __WEBPACK_IMPORTED_MODULE_0__components_app_AppDashboard__["default"]
  },
  data: function data() {
    return {
      sidebarOpen: false
    };
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters['wordpress/account/isLoggedIn'];
    }
  },
  methods: {},
  created: function created() {
    if (false) console.log('App.vue created');
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_AppSidemenu__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_AppSidebar__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    'app-sidemenu': __WEBPACK_IMPORTED_MODULE_0__components_app_AppSidemenu__["default"],
    'app-sidebar': __WEBPACK_IMPORTED_MODULE_1__components_app_AppSidebar__["default"]
  },
  data: function data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    logout: function logout(ev) {
      this.$store.dispatch('wordpress/account/logout');
      this.dialogVisible = false;
      setTimeout(function () {
        window.location.reload();
      }, 500);
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpSidebar__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-sidemenu',
  components: {
    'mimic-amp-sidebar': __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpSidebar__["default"]
  },
  data: function data() {
    return {
      links: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].options.routes
    };
  },
  computed: {
    appName: {
      get: function get() {
        return this.$store.getters['app/name'];
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    username: {
      get: function get() {
        return this.$store.getters['wordpress/account/username'];
      }
    }
  },
  methods: {
    logout: function logout() {
      this.$emit('logout');
    }
  }
});

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/account module
 */
var types = {
  URL: 'url',
  USERNAME: 'username',
  PASSWORD: 'password',
  GET_ID: 'getId',
  LOGIN: 'login',
  LOGOUT: 'logout'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/media module
 */
var types = {
  FETCH: 'fetch',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/posts module
 */
var types = {
  FETCH: 'fetch',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  SELECT: 'select',
  DESELECT: 'deselect'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/pages module
 */
var types = {
  FETCH: 'fetch',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  SELECT: 'select',
  DESELECT: 'deselect'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(26);

/**
 * Store state for wordpress/themes module
 */


var initialState = {
  colors: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].colors,
  css: '',
  navigation: null,
  sidebar: null,
  footer: null
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/themes module
 */
var types = {
  FETCH: 'fetch',
  UPDATE: 'update'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Action and mutation types for wordpress/settings module
 */
var types = {
  FETCH: 'fetch',
  UPDATE: 'update'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      isLoading: false
    };
  },
  computed: {
    appName: {
      get: function get() {
        return this.$store.getters['app/name'];
      }
    },
    isLoggedIn: {
      get: function get() {
        return this.$store.getters['wordpress/account/isLoggedIn'];
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      },
      set: function set(value) {
        this.$store.commit('wordpress/account/url', value);
      }
    },
    username: {
      get: function get() {
        return this.$store.getters['wordpress/account/username'];
      },
      set: function set(value) {
        this.$store.commit('wordpress/account/username', value);
      }
    },
    password: {
      get: function get() {
        return this.$store.getters['wordpress/account/password'];
      },
      set: function set(value) {
        this.$store.commit('wordpress/account/password', value);
      }
    },
    background: function background() {
      return __webpack_require__(273);
    }
  },
  methods: {
    submit: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev) {
        var response, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;
                _context.next = 3;
                return this.$store.dispatch('wordpress/account/login');

              case 3:
                response = _context.sent;

                this.isLoading = false;

                if (!(response && response.error)) {
                  _context.next = 15;
                  break;
                }

                message = response.message + '\n\n ' + response.status + ' error: ' + response.statusText;
                _context.t0 = response.status;
                _context.next = _context.t0 === 403 ? 10 : _context.t0 === 404 ? 12 : 14;
                break;

              case 10:
                message = '正しいユーザー名／パスワードを入力してください';
                return _context.abrupt('break', 14);

              case 12:
                message = '正しいホームページURLを入力してください';
                return _context.abrupt('break', 14);

              case 14:
                this.$msgbox({
                  title: 'ログインできませんでした',
                  message: message,
                  confirmButtonText: 'OK'
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submit(_x) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-sidebar',
  components: {},
  props: ['side'],
  data: function data() {
    return {
      status: 'close'
    };
  },
  methods: {
    close: function close() {}
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpSidebar__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-sidebar',
  components: {
    'mimic-amp-sidebar': __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpSidebar__["default"]
  },
  data: function data() {
    return {
      links: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].options.routes,
      menuVisible: false
    };
  },
  computed: {
    appName: {
      get: function get() {
        return this.$store.getters['app/name'];
      }
    }
  },
  methods: {
    logout: function logout() {
      this.$emit('logout');
    }
  }
});

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_element_variables_scss__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scss_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_style_scss__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__scss_style_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

if (false) console.log('Bootstraping ' + store.getters['app/name'] + '...');

/**
 * パスカルケースからケバブケースへ変換
 *
 * @see https://gist.github.com/nblackburn/875e6ff75bc8ce171c758bf75f304707
 */
// function PascalToKebab (string) {
//   return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
// }

/**
 * コンポーネント群を読み込んでVueに登録
 */
__WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].componentsArray.forEach(function (item) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(item.meta.name, function () {
    return __webpack_require__(340)("./" + item.meta.type + '/' + item.meta.file + '/' + item.meta.file);
  });
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a });

/**
 * Define global variables
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae32f34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae32f34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */,
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/**
 * App Vuex Module
 */


/**
 * Store state for App module
 */
var state = {
  version: __WEBPACK_IMPORTED_MODULE_0__package_json___default.a.version,
  name: __WEBPACK_IMPORTED_MODULE_0__package_json___default.a.description

  /**
   * Action for App module
   */
};var actions = {};

/**
 * Mutations for App module
 */
var mutations = {};

/**
 * Getters for App module
 */
var getters = {
  version: function version(state) {
    return state.version;
  },
  name: function name(state) {
    return state.name;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {"name":"evsmacloud","version":"0.1.1","description":"EV-Sma クラウド","author":"YUKiYURi WEB","private":true,"scripts":{"dev":"node build/dev-server.js","build":"node build/build.js","unit":"jest --config test/unit/jest.conf.js --coverage","unit:watch":"jest --config test/unit/jest.conf.js --coverage --watchAll","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"axios":"^0.17.1","element-ui":"^2.0.11","lodash":"^4.17.4","marked":"^0.3.12","moment":"^2.20.1","vue":"^2.5.13","vue-color":"^2.4.3","vue-fab":"^2.1.1","vue-quill-editor":"^3.0.5","vue-router":"^3.0.1","vue2-editor":"^2.3.34","vuedraggable":"^2.16.0","vuex":"^3.0.1"},"devDependencies":{"autoprefixer":"^7.2.5","babel-core":"^6.26.0","babel-eslint":"^8.2.1","babel-jest":"^22.1.0","babel-loader":"^7.1.2","babel-plugin-dynamic-import-node":"^1.2.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.1","babel-preset-stage-2":"^6.24.1","babel-register":"^6.26.0","chalk":"^2.3.0","chromedriver":"^2.35.0","connect-history-api-fallback":"^1.5.0","copy-webpack-plugin":"^4.3.1","cross-env":"^5.1.3","cross-spawn":"^5.1.0","css-loader":"^0.28.9","css-to-string-loader":"^0.1.3","cssnano":"^3.10.0","element-theme-chalk":"^2.0.11","element-theme-default":"^1.4.13","eslint":"^4.16.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.9.0","eslint-plugin-html":"^4.0.2","eslint-plugin-import":"^2.8.0","eslint-plugin-node":"^5.2.1","eslint-plugin-promise":"^3.6.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.16.2","extract-text-webpack-plugin":"^3.0.2","file-loader":"^1.1.6","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.1","jest":"^22.1.4","jest-serializer-vue":"^0.3.0","nightwatch":"^0.9.19","node-sass":"^4.7.2","opn":"^5.2.0","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.3.0","post-loader":"^2.0.0","postcss-cssnext":"^3.1.0","rimraf":"^2.6.2","sass-loader":"^6.0.6","selenium-server":"^3.8.1","semver":"^5.5.0","shelljs":"^0.7.8","sw-precache-webpack-plugin":"^0.11.4","uglify-es":"^3.3.9","url-loader":"^0.6.2","vue-jest":"^1.4.0","vue-loader":"^13.7.0","vue-markdown-loader":"^2.3.0","vue-style-loader":"^3.1.1","vue-template-compiler":"^2.5.13","webpack":"^3.10.0","webpack-bundle-analyzer":"^2.9.2","webpack-dev-middleware":"^1.12.2","webpack-hot-middleware":"^2.21.0","webpack-merge":"^4.1.1"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wordpress_account_index__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wordpress_media_index__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wordpress_posts_index__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wordpress_pages_index__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wordpress_themes_index__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wordpress_settings_index__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordpress_status__ = __webpack_require__(269);
/**
 * WordPress Vuex Module
 */








/**
 * Store state for WordPress module
 */
var state = {};

/**
 * Action for WordPress module
 */
var actions = {};

/**
 * Mutations for WordPress module
 */
var mutations = {};

/**
 * Getters for WordPress module
 */
var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    account: __WEBPACK_IMPORTED_MODULE_0__wordpress_account_index__["a" /* default */],
    posts: __WEBPACK_IMPORTED_MODULE_2__wordpress_posts_index__["a" /* default */],
    pages: __WEBPACK_IMPORTED_MODULE_3__wordpress_pages_index__["a" /* default */],
    media: __WEBPACK_IMPORTED_MODULE_1__wordpress_media_index__["a" /* default */],
    themes: __WEBPACK_IMPORTED_MODULE_4__wordpress_themes_index__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_5__wordpress_settings_index__["a" /* default */],
    status: __WEBPACK_IMPORTED_MODULE_6__wordpress_status__["a" /* default */]
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(243);
/**
 *  Vuex module wordpress/account
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Store state for wordpress/account module
 */
var initialState = {
  url: localStorage.getItem('url') || '',
  username: localStorage.getItem('username') || '',
  password: localStorage.getItem('password') || '',
  token: localStorage.getItem('token') || '',
  id: localStorage.getItem('id') || '',
  email: localStorage.getItem('email') || '',
  avatar_url: localStorage.getItem('avatar_url') || ''
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Getters for wordpress/account module
 */
var getters = {
  id: function id(state) {
    return state.id;
  },
  url: function url(state) {
    return state.url;
  },
  username: function username(state) {
    return state.username;
  },
  password: function password(state) {
    return state.password;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.token !== '' && state.id !== '' && state.email !== '';
  },
  authorizationHeader: function authorizationHeader(state) {
    return 'Bearer ' + state.token;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(110);





var _actions;

/**
 * Action for wordpress/account module
 */





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].LOGIN, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__api_wordpress__["a" /* default */].getToken({
              username: getters.username,
              password: getters.password
            }).then(function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                var error;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].LOGIN, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, res.data));
                        _context.next = 3;
                        return dispatch(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].GET_ID);

                      case 3:
                        error = _context.sent;

                        if (!error) {
                          _context.next = 6;
                          break;
                        }

                        return _context.abrupt('return', error);

                      case 6:
                        return _context.abrupt('return', null);

                      case 7:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()).catch(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].LOGOUT, function (_ref3) {
  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      getters = _ref3.getters,
      rootGetters = _ref3.rootGetters;

  commit(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].LOGOUT);
  __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push('/');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].GET_ID, function (_ref4) {
  var _this2 = this;

  var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      getters = _ref4.getters,
      rootGetters = _ref4.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__api_wordpress__["a" /* default */].getUsers().then(function () {
              var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                var user;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        user = res.data.find(function (user) {
                          return getters.username === user.name;
                        });

                        commit(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* default */].GET_ID, { id: user.id, avatar_urls: user.avatar_urls });
                        return _context3.abrupt('return', null);

                      case 3:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this2);
              }));

              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }()).catch(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this2);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"meta":{"file":"NavigationStandard1","name":"navigation-standard-1","type":"navigation","title":"標準的なナビゲーションバーコンポーネント 1","description":"標準的なナビゲーションバーコンポーネントです。タブレット・デスクトップのみ表示します。子ページはホバー時に表示されます。"},"contents":{"linkIds":[],"tel":"","open":"平日10:00〜19:30（土曜16:00迄）","menuIds":[]},"html":"","css":{"layout":"","theme":""}},{"id":1001,"meta":{"file":"SidebarStandard1","name":"sidebar-standard-1","type":"sidebar","title":"標準的なサイドバーコンポーネント 1","description":"標準的なサイドバーコンポーネントです。スマホのときのみ表示させます。"},"contents":{"icon":{"bg":"","color":""}},"html":"","css":{"layout":"","theme":""}},{"id":2001,"meta":{"file":"FooterCompany1","name":"footer-company-1","type":"footer","title":"コーポレートサイト向けフッターコンポーネント 1","description":"企業サイト向けのフッターコンポーネントです。"},"contents":{"linkIds":[],"copyright":{"bg":"","color":""}},"html":"","css":{"layout":"","theme":""}},{"id":4001,"meta":{"file":"SlideWithImage","name":"slide-with-image","type":"contents","tags":["text","image","link"],"title":"画像とテキストコンテンツを並べるコンポーネント","description":"画像とテキストコンテンツを並べるコンポーネントです。スマホでは画像とテキストコンテンツが上下に、デスクトップでは左右に並びます。"},"contents":{"heading":{"text":"これは見出しです","color":""},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""},"list":[],"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"left"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4002,"meta":{"file":"PostList1","name":"post-list-1","type":"contents","tags":["post"],"title":"投稿一覧表示用コンポーネント","description":"最新の投稿の一覧を表示します。"},"extensions":[],"contents":{"heading":{"text":"新着情報"},"perPage":5,"eyecatch":{"maxWidth":100},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4003,"meta":{"file":"CarouselStandard1","name":"carousel-standard-1","type":"contents","tags":["image"],"title":"カルーセルコンポーネント","description":"画像をカルーセル表示するコンポーネントです。使用する画像のサイズを合わせてください。"},"extensions":["amp-carousel"],"contents":{"images":[],"delay":5000,"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4004,"meta":{"file":"FiveBlockLinksForDriving","name":"five-block-links-for-driving","type":"contents","tags":["text","link"],"title":"5つのリンク用コンポーネント","description":"5つのリンクを表示するコンポーネントです。リンクテキストにはアイコンとテキストを並べます。"},"contents":{"heading":{"text":"これは見出しです","color":""},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""},"links":[{"icon":"car","pageId":null},{"icon":"motorcycle","pageId":null},{"icon":"truck","pageId":null},{"icon":"taxi","pageId":null},{"icon":"id-card","pageId":null}],"theme":{"isCustom":false,"color":"rgba(255,255,255,1)"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4005,"meta":{"file":"Youtube1","name":"youtube-1","type":"contents","tags":["movie"],"title":"Youtube動画埋め込み用コンポーネント","description":"Youtube動画を表示するコンポーネントです。"},"contents":{"id":"","fullWidth":false,"rel":false,"controls":false,"showinfo":false,"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"extensions":["amp-youtube"],"html":"","css":{"layout":"","theme":""}},{"id":4006,"meta":{"file":"SlideImage1","name":"slide-image-1","type":"contents","tags":["image","link"],"title":"画像表示用コンポーネント","description":"画像を表示するコンポーネントです。画像にリンクを設定することも可能です。"},"contents":{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"link":{"href":"","blank":false},"fullWidth":false,"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4007,"meta":{"file":"SlideWithText1","name":"slide-with-text-1","type":"contents","tags":["text"],"title":"見出しと段落用コンポーネント","description":"見出しと段落を表示するコンポーネントです。"},"contents":{"heading":{"text":"これは見出しです","color":""},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4008,"meta":{"file":"RichTextEditor1","name":"rich-text-editor-1","type":"contents","tags":["text"],"title":"リッチテキストエディタ用コンポーネント","description":"リッチテキストエディタでテキストを編集するコンポーネントです。このコンポーネントを使用すると、該当ページがAMP HTML非対応になる可能性があります。"},"contents":{"html":"<h1>見出しです</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>","padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4009,"meta":{"file":"SlideImage2","name":"slide-image-2","type":"contents","tags":["image","link"],"title":"位置・サイズ調整可能な画像用コンポーネント","description":"画像を表示するコンポーネントです。位置やサイズの詳細な調整ができます。"},"contents":{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"link":{"href":"","blank":false},"smartphone":{"size":100,"position":"center"},"tablet":{"size":100,"position":"center"},"desktop":{"size":50,"position":"center"},"fullWidth":false,"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4010,"meta":{"file":"MailContactImage1","name":"mail-contact-image-1","type":"contents","tags":["mail"],"title":"メール起動用コンポーネント","description":"画像をクリックするとメールアプリが起動するコンポーネントです。"},"contents":{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"mail":{"to":"","subject":{"text":"問い合わせ"},"body":{"text":"◎お名前：\n\r◎ご連絡先：\n\r◎お問い合わせ内容："}},"maxWidth":350,"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4011,"meta":{"file":"Table1","name":"table-1","type":"contents","tags":["table"],"title":"２列のテーブル表示用コンポーネント","description":"２列のテーブル（表）を表示するコンポーネントです。"},"contents":{"heading":{"text":"テーブル見出し"},"paragraph":{"text":"テーブルの説明が必要な場合はここに入力してください。"},"note":{"text":"テーブルの補足説明等が必要な場合はここに入力してください。"},"table":[[{"text":"列１-行１","href":""},{"text":"列１-行２","href":""}],[{"text":"列２-行１","href":""},{"text":"列２-行２","href":""}],[{"text":"列３-行１","href":""},{"text":"列３-行２","href":""}],[{"text":"列４-行１","href":""},{"text":"列４-行２","href":""}],[{"text":"列５-行１","href":""},{"text":"列５-行２","href":""}]],"head":{"isCustom":false,"color":"rgba(255,255,255,1)"},"body":{"isCustom":false,"color":"rgba(255,255,255,1)"},"alt":{"isCustom":false,"color":"rgba(255,255,255,1)"},"link":{"isCustom":false,"color":"rgba(0,0,0,1)"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4012,"meta":{"file":"Table2","name":"table-2","type":"contents","tags":["table"],"title":"３列のテーブル表示用コンポーネント","description":"３列のテーブル（表）を表示するコンポーネントです。"},"contents":{"heading":{"text":"テーブル見出し"},"paragraph":{"text":"テーブルの説明が必要な場合はここに入力してください。"},"note":{"text":"テーブルの補足説明等が必要な場合はここに入力してください。"},"table":[[{"text":"列１-行１","href":""},{"text":"列１-行２","href":""},{"text":"列１-行３","href":""}],[{"text":"列２-行１","href":""},{"text":"列２-行２","href":""},{"text":"列２-行３","href":""}],[{"text":"列３-行１","href":""},{"text":"列３-行２","href":""},{"text":"列３-行３","href":""}],[{"text":"列４-行１","href":""},{"text":"列４-行２","href":""},{"text":"列４-行３","href":""}],[{"text":"列５-行１","href":""},{"text":"列５-行２","href":""},{"text":"列５-行３","href":""}]],"head":{"isCustom":false,"color":"rgba(255,255,255,1)"},"body":{"isCustom":false,"color":"rgba(255,255,255,1)"},"alt":{"isCustom":false,"color":"rgba(255,255,255,1)"},"link":{"isCustom":false,"color":"rgba(0,0,0,1)"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4013,"meta":{"file":"Table3","name":"table-3","type":"contents","tags":["table"],"title":"４列のテーブル表示用コンポーネント","description":"４列のテーブル（表）を表示するコンポーネントです。"},"contents":{"heading":{"text":"テーブル見出し"},"paragraph":{"text":"テーブルの説明が必要な場合はここに入力してください。"},"note":{"text":"テーブルの補足説明等が必要な場合はここに入力してください。"},"table":[[{"text":"列１-行１","href":""},{"text":"列１-行２","href":""},{"text":"列１-行３","href":""},{"text":"列１-行４","href":""}],[{"text":"列２-行１","href":""},{"text":"列２-行２","href":""},{"text":"列２-行３","href":""},{"text":"列１-行４","href":""}],[{"text":"列３-行１","href":""},{"text":"列３-行２","href":""},{"text":"列３-行３","href":""},{"text":"列１-行４","href":""}],[{"text":"列４-行１","href":""},{"text":"列４-行２","href":""},{"text":"列４-行３","href":""},{"text":"列１-行４","href":""}],[{"text":"列５-行１","href":""},{"text":"列５-行２","href":""},{"text":"列５-行３","href":""},{"text":"列１-行４","href":""}]],"head":{"isCustom":false,"color":"rgba(255,255,255,1)"},"body":{"isCustom":false,"color":"rgba(255,255,255,1)"},"link":{"isCustom":false,"color":"rgba(0,0,0,1)"},"alt":{"isCustom":false,"color":"rgba(255,255,255,1)"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4014,"meta":{"file":"SlideImages1","name":"slide-images-1","type":"contents","tags":["image"],"title":"画像を並べて表示するコンポーネント","description":"画像を並べて表示するためのコンポーネントです。スマートフォンでは横に最大3枚まで、タブレットでは横に最大4枚まで、デスクトップでは横に最大6枚まで並べることができます。"},"contents":{"items":[{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"link":{"href":"","blank":false}},{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"link":{"href":"","blank":false}}],"layout":{"s":2,"m":2,"l":2,"margin":2},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4015,"meta":{"file":"GoogleMap1","name":"google-map-1","type":"contents","tags":["map"],"title":"Google Map表示するコンポーネント","description":"Google Mapを表示するためのコンポーネントです。"},"contents":{"src":"","height":{"s":300,"m":400,"l":500},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"extensions":["amp-iframe"],"html":"","css":{"layout":"","theme":""}},{"id":4016,"meta":{"file":"Card1","name":"card-1","type":"contents","tags":["text","image"],"title":"画像とテキストを含むカードタイプコンポーネント","description":"上に画像、下に見出しとテキストを表示するカードを並べるコンポーネントです。"},"contents":{"items":[{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"heading":{"text":"これは見出しです","color":"","before":{"text":"Point 1","color":""}},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""}},{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"heading":{"text":"これは見出しです","color":"","before":{"text":"Point 2","color":""}},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""}},{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"heading":{"text":"これは見出しです","color":"","before":{"text":"Point 3","color":""}},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""}},{"image":{"id":0,"src":"http://via.placeholder.com/350x150","width":350,"height":150},"heading":{"text":"これは見出しです","color":"","before":{"text":"Point 4","color":""}},"paragraph":{"text":"あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。","color":""}}],"layout":{"s":1,"m":2,"l":4,"margin":2},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4017,"meta":{"file":"Iframe1","name":"iframe-1","type":"contents","tags":["etc"],"title":"外部サイトを表示するコンポーネント","description":"外部サイトを表示するためのコンポーネントです。"},"contents":{"src":"","height":{"s":300,"m":400,"l":500},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"extensions":["amp-iframe"],"html":"","css":{"layout":"","theme":""}},{"id":4018,"meta":{"file":"LinkButtons1","name":"link-buttons-1","type":"contents","tags":["link"],"title":"リンク用ボタンを並べて表示するコンポーネント","description":"リンク用ボタンを並べて表示するコンポーネントです。スマートフォンでは横に最大2つまで、タブレットでは横に最大3つまで、デスクトップでは横に最大4つまで並べることができます。"},"contents":{"items":[{"href":"","text":"リンク先テキスト","color":"","blank":false},{"href":"","text":"リンク先テキスト","color":"","blank":false}],"layout":{"s":1,"m":2,"l":2,"margin":2},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4019,"meta":{"file":"LinkButtons2","name":"link-buttons-2","type":"contents","tags":["link"],"title":"内部リンク用ボタンを並べて表示するコンポーネント","description":"内部リンク用ボタンを並べて表示するコンポーネントです。リンクに設定したページではリンクボタンの色が反転します。スマートフォンでは横に最大2つまで、タブレットでは横に最大4つまで、デスクトップでは横に最大6つまで並べることができます。"},"contents":{"items":[{"icon":"car","pageId":null,"color":""},{"icon":"motorcycle","pageId":null,"color":""},{"icon":"truck","pageId":null,"color":""},{"icon":"taxi","pageId":null,"color":""}],"layout":{"s":2,"m":2,"l":4,"margin":0},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4020,"meta":{"file":"AnchorLinkButtons1","name":"anchor-link-buttons-1","type":"contents","tags":["link"],"title":"アンカーリンク用ボタンを並べて表示するコンポーネント","description":"アンカーリンク（ページ内リンク）用ボタンを並べて表示するコンポーネントです。スマートフォンでは横に最大2つまで、タブレットでは横に最大3つまで、デスクトップでは横に最大4つまで並べることができます。"},"contents":{"items":[{"componentId":null,"anchor":{"text":"リンクボタンのテキスト1","color":""},"before":{"text":"補助テキスト1","color":""}},{"componentId":null,"anchor":{"text":"リンクボタンのテキスト2","color":""},"before":{"text":"補助テキスト2","color":""}},{"componentId":null,"anchor":{"text":"リンクボタンのテキスト3","color":""},"before":{"text":"補助テキスト3","color":""}},{"componentId":null,"anchor":{"text":"リンクボタンのテキスト4","color":""},"before":{"text":"補助テキスト4","color":""}}],"animation":{"duration":300},"layout":{"s":1,"m":2,"l":2,"margin":0},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}},{"id":4021,"meta":{"file":"GridRichTextEditor1","name":"grid-rich-text-editor-1","type":"contents","tags":["text"],"title":"グリッド状に見出しとテキストを並べるコンポーネント","description":"グリッド状に見出しとテキストを並べるコンポーネントです。リッチテキストエディタでテキストを編集するコンポーネントです。このコンポーネントを使用すると、該当ページがAMP HTML非対応になる可能性があります。"},"contents":{"items":[{"html":"<h1>見出し1です</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>"},{"html":"<h1>見出し2です</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>"},{"html":"<h1>見出し3です</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>"},{"html":"<h1>見出し4です</h1><p>あのイーハトーヴォのすきとおった風、夏でも底に冷たさをもつ青いそら、うつくしい森で飾られたモリーオ市、郊外のぎらぎらひかる草の波。</p>"}],"layout":{"s":1,"m":2,"l":2,"margin":5},"padding":{"y":3},"fullWidth":false,"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}},"html":"","css":{"layout":"","theme":""}}]

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = [{"id":1001,"meta":{"name":"top","type":"driving","title":"自動車教習所 トップページ","description":"自動車教習所のトップページ用テンプレートです。カルーセル、リンクボタン、お知らせ一覧が並びます。"},"components":[4003,4004,4002]},{"id":1002,"meta":{"name":"reasons","type":"driving","title":"自動車教習所 選ばれる理由ページ","description":"自動車教習所の選ばれる理由ページ用テンプレートです。画像とテキストを左右に配置するコンポーネントが４つ並びます。"},"components":[{"id":4001,"contents":{"heading":{"text":"理由その１：理由を入力してください","color":""},"paragraph":{"text":"選ばれる理由についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"left"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}},{"id":4001,"contents":{"heading":{"text":"理由その２：理由を入力してください","color":""},"paragraph":{"text":"選ばれる理由についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"right"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}},{"id":4001,"contents":{"heading":{"text":"理由その３：理由を入力してください","color":""},"paragraph":{"text":"選ばれる理由についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"left"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}},{"id":4001,"contents":{"heading":{"text":"理由その４：理由を入力してください","color":""},"paragraph":{"text":"選ばれる理由についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"right"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}}]},{"id":1003,"meta":{"name":"courses","type":"driving","title":"自動車教習所 講習一覧ページ","description":"自動車教習所の講習一覧ページ用テンプレートです。画像とテキストを左右に配置するコンポーネントが３つ並びます。"},"components":[{"id":4001,"contents":{"heading":{"text":"講習その１","color":""},"paragraph":{"text":"講習についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"right"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}},{"id":4001,"contents":{"heading":{"text":"講習その２","color":""},"paragraph":{"text":"講習についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"right"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}},{"id":4001,"contents":{"heading":{"text":"講習その３","color":""},"paragraph":{"text":"講習についてその詳細を入力してください。画像は適切な画像に入れ替えてください。","color":""},"list":[],"image":{"src":"http://via.placeholder.com/350x150","width":350,"height":150,"position":"right"},"link":{"text":"","href":"","form":"round"},"padding":{"y":3},"bg":{"isCustom":false,"color":"rgba(255,255,255,1)"}}}]}]

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = {"base":{"hex":"#ffffff","hsl":{"h":150,"s":0,"l":1,"a":1},"hsv":{"h":150,"s":0,"v":1,"a":1},"rgba":{"r":255,"g":255,"b":255,"a":1},"a":1},"main":{"hex":"#F2F2F2","hsl":{"h":150,"s":0,"l":0.9490196078431372,"a":1},"hsv":{"h":150,"s":0,"v":0.9490196078431372,"a":1},"rgba":{"r":242,"g":242,"b":242,"a":1},"a":1},"accent":{"hex":"#C8161E","hsl":{"h":357.30337078651684,"s":0.8018018018018017,"l":0.43529411764705883,"a":1},"hsv":{"h":357.30337078651684,"s":0.89,"v":0.7843137254901961,"a":1},"rgba":{"r":200,"g":22,"b":30,"a":1},"a":1}}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = {"site":{"meta":{"heading":"サイトの設定","description":"サイト所有者を入力してください。"},"owner":{"type":"text","name":"サイトの所有者名","required":true,"placeholder":"YUKiYURi WEB"},"logo":{"meta":{"heading":"ヘッダー・フッター用ロゴ画像の設定","description":"ヘッダー・フッター用ロゴ画像を設定してください。","image":true},"src":{"type":"text","name":"ヘッダー・フッター用ロゴ画像のURL","required":true,"placeholder":"https: //yukiyuriweb.com/wp-content/uploads/2017/07/07/ogp.jpg","default":"https://via.placeholder.com/700x180"},"width":{"type":"number","name":"ヘッダー・フッター用ロゴ画像の幅","required":true,"placeholder":700,"default":700},"height":{"type":"number","name":"ヘッダー・フッター用ロゴ画像の高さ","required":true,"placeholder":180,"default":180}}},"ogp":{"meta":{"heading":"OGP (Open Graph Protocol) の設定","description":"SEO対策のためにOGP画像を選択してください。","image":true},"src":{"type":"text","name":"OGP画像のURL","placeholder":"https: //yukiyuriweb.com/wp-content/uploads/2017/07/07/ogp.jpg","default":"https://via.placeholder.com/1200x690"},"width":{"type":"number","name":"OGP画像の幅","placeholder":1200,"default":1200},"height":{"type":"number","name":"OGP画像の幅","placeholder":690,"default":690}},"twitter":{"meta":{"heading":"Twitterアカウント","description":"SEO対策のためにTwitterアカウント情報を入力してください。アカウント名は@を含めてください。"},"card":{"type":"text","name":"Twitterカードタイプ","placeholder":"summary_large_image","default":"summary_large_image","readonly":true},"owner":{"type":"text","name":"サイト所有者のTwitterアカウント","placeholder":"@YUKiYURi_WEB"},"creator":{"type":"text","name":"サイト制作者のTwitterアカウント","placeholder":"@YUKiYURi_WEB"}},"facebook":{"meta":{"heading":"Facebookアカウント","description":"SEO対策のためにFacebookアカウント情報を入力してください。"},"id":{"type":"text","name":"Facebook ID","placeholder":"YUKiYURi_WEB"},"appId":{"type":"text","name":"Facebook App ID","placeholder":"1226693330723439"}},"googlePlus":{"meta":{"heading":"Google+アカウント","description":"SEO対策のためにGoogle+アカウント情報を入力してください。"},"id":{"type":"text","name":"Google+ ID","placeholder":"116534698309738184426"}},"instagram":{"meta":{"heading":"Instagramアカウント","description":"Instagramのアカウント情報を入力してください。"},"id":{"type":"text","name":"Instagram ID","placeholder":"YUKiYURi_WEB"}},"youtube":{"meta":{"heading":"Youtubeアカウント","description":"Youtubeのアカウント情報を入力してください。"},"id":{"type":"text","name":"Youtube Channel ID","placeholder":"UCYfdidRxbB8Qhf0Nx7ioOYw"}},"verification":{"meta":{"heading":"サイトの所有権の確認","description":"SEO対策のためにGoogle検索, Bing検索でのサイト所有権確認情報を入力してください。"},"google":{"type":"text","name":"GoogleでのVerification ID","placeholder":"Sqkz2N00tInONfYn9COMFyai5pxj7HGp0nmamITyab0"},"bing":{"type":"text","name":"BingでのVerification ID","placeholder":"1AEF9D57A752326D3F5B573A81626579"}},"tracking":{"meta":{"heading":"Google Analyticsでのアクセス解析","description":"Google Analyticsでアクセス解析を行うためのコードを埋め込むため、『UA-』で始まるAnalyticsのトラッキングIDを入力してください。"},"google":{"type":"text","name":"Tracking ID","placeholder":"UA-84268757-1"}},"publisher":{"meta":{"heading":"発行者（出版者）名","description":"SEO対策のために必要な構造化データの情報を入力してください。構造化データ用のロゴは600x60のサイズを用意してください。"},"name":{"type":"text","name":"発行者（出版者）名","placeholder":"YUKiYURi WEB"},"logo":{"meta":{"heading":"発行者（出版者）用ロゴ画像の設定","description":"発行者（出版者）用ロゴ画像を設定してください。","image":true},"src":{"type":"text","name":"発行者（出版者）ロゴ画像","placeholder":"https: //yukiyuriweb.com/wp-content/uploads/2017/07/07/ogp.jpg","default":"https://via.placeholder.com/600x60"},"width":{"type":"number","name":"発行者（出版者）ロゴ画像の幅","placeholder":600,"default":600},"height":{"type":"number","name":"発行者（出版者）ロゴ画像の高さ","placeholder":60,"default":60}}},"address":{"meta":{"heading":"所在地","description":"SEO対策のために必要な構造化データの情報を入力してください。"},"latitude":{"type":"text","name":"緯度","placeholder":"35.0419835"},"longitude":{"type":"text","name":"経度","placeholder":"135.980264"},"addressCountry":{"type":"text","name":"国","placeholder":"JP","default":"JP"},"postalCode":{"type":"text","name":"郵便番号","placeholder":"524-0036"},"addressRegion":{"type":"text","name":"都道府県","placeholder":"滋賀県"},"addressLocality":{"type":"text","name":"市区町村","placeholder":"守山市"},"streetAddress":{"type":"text","name":"市区町村以降","placeholder":"伊勢町433"}},"contact":{"meta":{"heading":"連絡先・問い合わせ先","description":"問い合わせ先の電話番号、FAX番号、メールアドレスを入力してください。"},"tel":{"type":"text","name":"電話番号","placeholder":"012-3456-7890"},"fax":{"type":"text","name":"FAX番号","placeholder":"098-7654-3210"},"email":{"type":"text","name":"メールアドレス","placeholder":"info@yukiyuriweb.com"}},"openingHoursSpecification":{"meta":{"heading":"営業時間","description":"SEO対策のために必要な構造化データの情報を入力してください。"},"opens":{"type":"text","name":"営業開始時間","placeholder":"10:00"},"closes":{"type":"text","name":"営業終了時間","placeholder":"18:00"},"dayOfWeek":{"type":"checkbox","name":"営業曜日","values":[{"name":"月曜日","value":"Monday","default":true},{"name":"火曜日","value":"Tuesday","default":true},{"name":"水曜日","value":"Wednesday","default":true},{"name":"木曜日","value":"Thursday","default":true},{"name":"金曜日","value":"Friday","default":true},{"name":"土曜日","value":"Saturday","default":false},{"name":"日曜日","value":"Sunday","default":false}]}}}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(110);


var _mutations;

/**
 *  Vuex module wordpress/account
 */


/**
 * Mutations for wordpress/account module
 */
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].URL, function (state, payload) {
  state.url = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].USERNAME, function (state, payload) {
  state.username = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].PASSWORD, function (state, payload) {
  state.password = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOGIN, function (state, payload) {
  state.token = payload.token;
  state.email = payload.user_email;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].GET_ID, function (state, payload) {
  state.id = payload.id;
  state.avatar_url = payload.avatar_urls['96'];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].LOGOUT, function (state, payload) {
  // localStorage.removeItem('token')
  // localStorage.removeItem('id')
  // localStorage.removeItem('email')
  state.token = '';
  state.id = '';
  state.email = '';
  // state.posts = []
  // state.post = null
  // state.pages = []
  // state.page = null
  // state.media = []
  // state.chat.message = ''
  // state.chat.messages = []
  // state.chat.lastMessage = null
  // state.settings = cloneDeep(getSettingsFromTemplate(settingsTemplate))
  // state.themes.colors = cloneDeep(defaultColors)
  // state.themes.css = ''
  // state.themes.header = {html: '', css: '', component: null}
  // state.themes.navigation = {html: '', css: '', component: null}
  // state.themes.sidebar = {html: '', css: '', component: null}
  // state.themes.footer = {html: '', css: '', component: null}
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(248);
/**
 *  Vuex module wordpress/media
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Store state for wordpress/media module
 */
var initialState = {
  media: []
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Getters for wordpress/media module
 */
var getters = {
  all: function all(state) {
    return state.media.filter(function (image) {
      return image.media_details.sizes.full;
    });
  },
  uploadPath: function uploadPath(state) {
    return '/wp-json/wp/v2/media';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(111);




var _actions;

/**
 * Action for wordpress/media module
 */




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].getMedia().then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, function (_ref2, option) {
  var _this2 = this;

  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      getters = _ref2.getters,
      rootGetters = _ref2.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].createMedia(option.file, {
              headers: {
                'Content-Type': '' + option.file.type,
                'Content-Disposition': 'attachment; filename="' + option.file.name + '"'
              },
              onUploadProgress: function onUploadProgress(e) {
                if (e.total > 0) {
                  e.percent = e.loaded / e.total * 100;
                }
                option.onProgress(e);
              }
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, res.data);
              return option.onSuccess(res);
            }).catch(function (err) {
              return option.onError(err);
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, function (_ref3, media) {
  var _this3 = this;

  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      getters = _ref3.getters,
      rootGetters = _ref3.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].updateMedia(media.id, {
              alt_text: media.alt_text
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, function (_ref4, media) {
  var _this4 = this;

  var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      getters = _ref4.getters,
      rootGetters = _ref4.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].deleteMedia(media.id).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, res.data.previous);
              return res.data.previous;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(111);


var _mutations;

/**
 * Mutations for wordpress/media module
 */


var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].FETCH, function (state, payload) {
  state.media = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].CREATE, function (state, payload) {
  if (!state.media.some(function (id) {
    return id === payload.id;
  })) {
    state.media.unshift(payload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].UPDATE, function (state, payload) {
  state.media[state.media.findIndex(function (item) {
    return item.id === payload.id;
  })] = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].DELETE, function (state, payload) {
  state.media.splice(state.media.findIndex(function (item) {
    return item.id === payload.id;
  }), 1);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(253);
/**
 *  Vuex module wordpress/posts
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Store state for wordpress/posts module
 */
var initialState = {
  posts: [
    // {
    //   ...post,
    //   components: '',
    //   header: '',
    //   css: '',
    //   extensions: ''
    // }
  ],
  selected: null
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Getters for wordpress/posts module
 */
var getters = {
  all: function all(state) {
    return state.posts;
  },
  published: function published(state) {
    return state.pages.filter(function (page) {
      return page.status === 'publish';
    });
  },
  selected: function selected(state) {
    return state.selected;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(112);




var _actions;

/**
 * Action for wordpress/posts module
 */




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].getPosts().then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, function (_ref2, post) {
  var _this2 = this;

  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      getters = _ref2.getters,
      rootGetters = _ref2.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].createPost({
              date: post.date,
              slug: post.slug,
              status: post.status,
              title: post.title,
              content: post.html,
              author: rootGetters['wordpress/account/id'],
              featured_media: post.featured_media,
              css: post.css,
              header: post.header,
              extensions: post.extensions,
              components: post.components
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, function (_ref3, post) {
  var _this3 = this;

  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      getters = _ref3.getters,
      rootGetters = _ref3.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            /**
             * 一度非公開にするとページタイトルに『非公開: 』という文字が追加される。
             * ここでは post.status が private 以外かつタイトルの頭に『非公開: 』がつく場合は
             * 『非公開: 』をタイトルから削除する
             */
            if (post.status !== 'private' && post.title.rendered.startsWith('非公開: ')) post.title.rendered = post.title.rendered.replace(/非公開: /, '');
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].updatePost(post.id, {
              date: post.date,
              slug: post.slug,
              status: post.status,
              title: post.title.rendered,
              content: post.html,
              featured_media: post.featured_media,
              css: post.css,
              header: post.header,
              extensions: post.extensions,
              components: post.components
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, function (_ref4, id) {
  var _this4 = this;

  var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      getters = _ref4.getters,
      rootGetters = _ref4.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].deletePost(id).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, res.data.previous);
              return res.data.previous;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(14);


var _mutations;

/**
 * Mutations for wordpress/posts module
 */



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].FETCH, function (state, payload) {
  state.posts = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].CREATE, function (state, payload) {
  if (!state.posts.some(function (id) {
    return id === payload.id;
  })) {
    state.posts.unshift(payload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].UPDATE, function (state, payload) {
  state.posts[state.posts.findIndex(function (post) {
    return post.id === payload.id;
  })] = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].DELETE, function (state, payload) {
  state.posts.splice(state.posts.findIndex(function (post) {
    return post.id === payload.id;
  }), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].SELECT, function (state, payload) {
  state.selected = state.posts[state.posts.findIndex(function (post) {
    return post.id === +payload;
  })];
  // state.selected.components内のコンポーネントで最新でないものをフィルターする
  if (state.selected.components) state.selected.components = state.selected.components.filter(function (component) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* isUpdatedComponent */])(component);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].DESELECT, function (state, payload) {
  state.selected = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(258);
/**
 *  Vuex module wordpress/pages
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Store state for wordpress/pages module
 */
var initialState = {
  pages: [
    // {
    //   ...page,
    //   components: '',
    //   header: '',
    //   css: '',
    //   extensions: ''
    // }
  ],
  selected: null
};

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Getters for wordpress/pages module
 */
var getters = {
  all: function all(state) {
    return state.pages;
  },
  published: function published(state) {
    return state.pages.filter(function (page) {
      return page.status === 'publish';
    });
  },
  selected: function selected(state) {
    return state.selected;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(113);




var _actions;

/**
 * Action for wordpress/pages module
 */




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].getPages().then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, function (_ref2, page) {
  var _this2 = this;

  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      getters = _ref2.getters,
      rootGetters = _ref2.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].createPage({
              date: page.date,
              slug: page.slug,
              status: page.status,
              parent: page.parent,
              title: page.title,
              content: page.html,
              author: rootGetters['wordpress/account/id'],
              menu_order: page.menu_order,
              css: page.css,
              header: page.header,
              extensions: page.extensions,
              components: page.components
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].CREATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, function (_ref3, page) {
  var _this3 = this;

  var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      getters = _ref3.getters,
      rootGetters = _ref3.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            /**
             * 一度非公開にするとページタイトルに『非公開: 』という文字が追加される。
             * ここでは page.status が private 以外かつタイトルの頭に『非公開: 』がつく場合は
             * 『非公開: 』をタイトルから削除する
             */
            if (page.status !== 'private' && page.title.rendered.startsWith('非公開: ')) page.title.rendered = page.title.rendered.replace(/非公開: /, '');
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].updatePage(page.id, {
              date: page.date,
              slug: page.slug,
              status: page.status,
              parent: page.parent,
              title: page.title.rendered,
              content: page.html,
              menu_order: page.menu_order,
              css: page.css,
              header: page.header,
              extensions: page.extensions,
              components: page.components
            }).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, function (_ref4, id) {
  var _this4 = this;

  var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      getters = _ref4.getters,
      rootGetters = _ref4.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].deletePage(id).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].DELETE, res.data.previous);
              return res.data.previous;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(14);



var _mutations;

/**
 * Mutations for wordpress/pages module
 */



/**
 * 親ページ
 *   子ページ
 *   子ページ
 * のように並べ替える
 */
function swapPages(pages) {
  /**
   * parent = 0のページをswappedに格納、各ページでhierarchyを0にセット
   * parent != 0のページをrestに格納
   */
  var swapped = pages.filter(function (item) {
    return item.parent === 0;
  }).map(function (page) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, page, { hierarchy: 0 });
  });
  var rest = pages.filter(function (item) {
    return item.parent !== 0;
  });
  var hierarchy = 0;
  while (rest.length > 0) {
    var remaining = [];
    hierarchy += 1;

    var _loop = function _loop(index) {
      var parentIndex = swapped.findIndex(function (parent) {
        return parent.id === rest[index].parent;
      });
      /**
       * page.parentがswapped配列に見つかった場合は
       * swappedに入っている同じparentをもつページを数え、
       * 兄弟ページの数だけ挿入位置をずらす
       */
      if (~parentIndex) {
        var siblings = swapped.filter(function (page) {
          return page.parent === rest[index].parent;
        });
        swapped.splice(parentIndex + siblings.length + 1, 0, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest[index], { hierarchy: hierarchy }));
      } else {
        remaining.push(rest[index]);
      }
    };

    for (var index = 0; index < rest.length; index++) {
      _loop(index);
    }
    rest = remaining;
  }
  return swapped;
}

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].FETCH, function (state, payload) {
  payload = payload.map(function (page) {
    page.components = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* migrateComponents */])(page.components);
    return page;
  });
  state.pages = payload;
  state.pages = swapPages(state.pages);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].CREATE, function (state, payload) {
  if (!state.pages.some(function (id) {
    return id === payload.id;
  })) {
    state.pages.unshift(payload);
  }
  state.pages = swapPages(state.pages);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].UPDATE, function (state, payload) {
  state.pages[state.pages.findIndex(function (page) {
    return page.id === payload.id;
  })] = payload;
  state.pages = swapPages(state.pages);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].DELETE, function (state, payload) {
  state.pages.splice(state.pages.findIndex(function (page) {
    return page.id === payload.id;
  }), 1);
  state.pages = swapPages(state.pages);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].SELECT, function (state, payload) {
  state.selected = state.pages[state.pages.findIndex(function (page) {
    return page.id === +payload;
  })];
  // state.selected.components内のコンポーネントで最新でないものをフィルターする
  if (state.selected.components) state.selected.components = state.selected.components.filter(function (component) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* isUpdatedComponent */])(component);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */].DESELECT, function (state, payload) {
  state.selected = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(263);
/**
 *  Vuex module wordpress/themes
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Getters for wordpress/themes module
 */
var getters = {
  all: function all(state) {
    return state;
  },
  json: function json(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state, null, 4);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(115);




var _actions;

/**
 * Action for wordpress/themes module
 */




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].getThemes().then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, function (_ref2, themes) {
  var _this2 = this;

  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      getters = _ref2.getters,
      rootGetters = _ref2.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].updateThemes(themes).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(115);



var _mutations;

/**
 * Mutations for wordpress/themes module
 */



var themesProps = ['colors', 'css', 'navigation', 'sidebar', 'footer'];

function treeShake(state) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (prop) {
    if (!themesProps.includes(prop)) delete state[prop];
  });
}

function mutate(state, payload) {
  themesProps.forEach(function (prop) {
    state[prop] = payload && payload[prop] ? payload[prop] : __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */][prop];
  });
}

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].FETCH, function (state, payload) {
  treeShake(state);
  mutate(state, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].UPDATE, function (state, payload) {
  treeShake(state);
  mutate(state, payload);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(268);
/**
 *  Vuex module wordpress/settings
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(26);

/**
 * Store state for wordpress/settings module
 */


var initialState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].settingsDefault);

var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState);

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Getters for wordpress/settings module
 */
var getters = {
  all: function all(state) {
    return state;
  },
  json: function json(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state, null, 4);
  },
  logo: function logo(state) {
    return state.site.logo;
  },
  owner: function owner(state) {
    return state.site.owner;
  },
  contact: function contact(state) {
    return state.contact;
  },
  fullAddress: function fullAddress(state) {
    return !state.address.postalCode || !state.address.addressRegion || !state.address.addressLocality || !state.address.streetAddress ? '' : '\u3012' + state.address.postalCode + ' ' + state.address.addressRegion + state.address.addressLocality + state.address.streetAddress;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_wordpress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(116);




var _actions;

/**
 * Action for wordpress/settings module
 */




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, function (_ref) {
  var _this = this;

  var dispatch = _ref.dispatch,
      commit = _ref.commit,
      getters = _ref.getters,
      rootGetters = _ref.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].getSettings().then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].FETCH, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, function (_ref2, settings) {
  var _this2 = this;

  var dispatch = _ref2.dispatch,
      commit = _ref2.commit,
      getters = _ref2.getters,
      rootGetters = _ref2.rootGetters;
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_wordpress__["a" /* default */].updateSettings(settings).then(function (res) {
              commit(__WEBPACK_IMPORTED_MODULE_5__types__["a" /* default */].UPDATE, res.data);
              return res.data;
            }).catch(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* errorHandler */]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(116);



var _mutations;

/**
 * Mutations for wordpress/settings module
 */



function treeShake(state) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state).forEach(function (prop) {
    if (!__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].settingsProps.includes(prop)) delete state[prop];
  });
}

function mutate(state, payload) {
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].settingsProps.forEach(function (prop) {
    state[prop] = payload && payload[prop] ? payload[prop] : __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].settingsDefault[prop];
  });
}

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].FETCH, function (state, payload) {
  treeShake(state);
  mutate(state, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* default */].UPDATE, function (state, payload) {
  treeShake(state);
  mutate(state, payload);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * wordpress/status Vuex Module
 */

/**
 * Store state for wordpress/status module
 */
var state = {
  isThemesLoaded: false,
  isSettingsLoaded: false

  /**
   * Action for wordpress/status module
   */
};var actions = {};

/**
 * Mutations for wordpress/status module
 */
var mutations = {
  themesLoaded: function themesLoaded(state, payload) {
    state.isThemesLoaded = true;
  },
  settingsLoaded: function settingsLoaded(state, payload) {
    state.isSettingsLoaded = true;
  }

  /**
   * Getters for wordpress/status module
   */
};var getters = {
  isThemesLoaded: function isThemesLoaded(state) {
    return state.isThemesLoaded;
  },
  isSettingsLoaded: function isSettingsLoaded(state) {
    return state.isSettingsLoaded;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Admin.vue": [
		72,
		8
	],
	"./Error404.vue": [
		73,
		10
	],
	"./Home.vue": [
		74,
		5
	],
	"./Login.vue": [
		41
	],
	"./Media.vue": [
		75,
		7
	],
	"./MediaUpload.vue": [
		76,
		9
	],
	"./Page.vue": [
		77,
		1
	],
	"./Pages.vue": [
		78,
		4
	],
	"./Post.vue": [
		79,
		0
	],
	"./Posts.vue": [
		80,
		2
	],
	"./Settings.vue": [
		81,
		6
	],
	"./Themes.vue": [
		82,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 271;
module.exports = webpackAsyncContext;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.215c7f5.jpg";

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.isLoading),expression:"isLoading",modifiers:{"fullscreen":true}}],attrs:{"element-loading-text":"Logging in..."}},[_c('div',{staticClass:"login flex justify-center items-center",style:({backgroundImage: 'url(' + _vm.background + ')'})},[_c('div',{staticClass:"login-inner"},[_c('h1',{staticClass:"login-h1"},[_vm._v(_vm._s(_vm.appName))]),_vm._v(" "),_c('el-form',[_c('el-input',{attrs:{"required":"","placeholder":"ホームページURL"},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}}),_vm._v(" "),_c('el-input',{attrs:{"required":"","placeholder":"ユーザー名"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('el-input',{attrs:{"required":"","type":"password","placeholder":"パスワード"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("Login")])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['sidebar', 'theme-base-bg-color', _vm.status, _vm.side]},[_c('button',{staticClass:"sidebar-button close",on:{"click":function($event){_vm.status = 'close'}}},[_c('svg',{staticClass:"sidebar-svg theme-accent-fill-color",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5 c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9 c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"}})])]),_vm._v(" "),_vm._t("default",[_vm._v("Contents here")])],2),_vm._v(" "),_c('button',{staticClass:"sidebar-button open",on:{"click":function($event){_vm.status = 'open'}}},[_c('svg',{staticClass:"sidebar-svg theme-accent-fill-color",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,238.3,434.3,224,417.4,224z"}}),_c('path',{attrs:{"d":"M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,110.3,434.3,96,417.4,96z"}}),_c('path',{attrs:{"d":"M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,366.3,434.3,352,417.4,352z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidemenu flex column justify-start items-center"},[_c('header',{staticClass:"sidemenu-header flex column justify-center items-center py4 px2"},[_c('h1',{staticClass:"sidemenu-header-h1 mx0 mt0 mb2"},[_vm._v(_vm._s(_vm.appName))]),_vm._v(" "),_c('div',{staticClass:"sidemenu-user flex column justify-center items-center"},[_c('span',{staticClass:"sidemenu-user-span flex justify-start items-center col-12"},[_c('i',{staticClass:"fa fa-fw fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('a',{staticClass:"sidemenu-user-a flex justify-start items-center",attrs:{"href":_vm.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-fw fa-wordpress",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"sidemenu-user-a-span"},[_vm._v(_vm._s(_vm.url))])])]),_vm._v(" "),_c('button',{staticClass:"logout-button",on:{"click":_vm.logout}},[_vm._v("LOGOUT")])]),_vm._v(" "),_c('nav',{staticClass:"sidemenu-nav"},[_c('ul',{staticClass:"sidemenu-list"},[_vm._l((_vm.links),function(link,index){return [(link.icon)?[_c('li',{staticClass:"sidemenu-item"},[_c('router-link',{staticClass:"sidemenu-a flex justify-start items-center",attrs:{"to":link.path}},[_c('span',{staticClass:"sidemenu-icon"},[_c('div',{staticClass:"sidemenu-icon-before",style:('background-color:' + link.color)}),_vm._v(" "),_c('i',{class:['fa', 'fa-fw', 'flex', 'justify-center', 'items-center', 'fa-' + link.icon],attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"sidemenu-span block"},[_vm._v(_vm._s(link.ja))])])],1)]:_vm._e()]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"sidebar-nav"},[_c('h2',{staticClass:"sidebar-nav-h2",on:{"click":function($event){_vm.menuVisible = !_vm.menuVisible}}},[_c('a',{staticClass:"sidebar-nav-a"},[_vm._v(_vm._s(_vm.appName)+" MENU")])]),_vm._v(" "),_c('ul',{staticClass:"sidebar-nav-list",class:[_vm.menuVisible ? 'show' : 'hide']},[_vm._l((_vm.links),function(link,index){return [(link.icon)?[(link.premium ? _vm.isAmpress: true)?[_c('li',{key:index,staticClass:"sidebar-nav-item",on:{"click":function($event){_vm.sidebarOpen = false}}},[_c('router-link',{staticClass:"sidebar-nav-item-a",attrs:{"to":link.path}},[_vm._v(_vm._s(link.ja)),_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])],1)]:_vm._e()]:_vm._e()]}),_vm._v(" "),_c('li',{staticClass:"sidebar-nav-item"},[_c('a',{staticClass:"sidebar-nav-item-a",on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v("Logout")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dashboard"},[_c('app-sidemenu',{staticClass:"app-sidemenu",on:{"logout":function($event){_vm.dialogVisible = true}}}),_vm._v(" "),_c('router-view',{staticClass:"app-router"}),_vm._v(" "),_c('app-sidebar',{staticClass:"app-sidebar",on:{"logout":function($event){_vm.dialogVisible = true}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"280px","title":"Logout","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_vm._v("ログアウトしますか？")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("いいえ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.logout}},[_vm._v("はい")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?[_c('dashboard')]:[_c('login')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app/AppDashboard": [
		44
	],
	"./app/AppDashboard.vue": [
		44
	],
	"./app/AppHeader": [
		142,
		45
	],
	"./app/AppHeader.vue": [
		142,
		45
	],
	"./app/AppSidebar": [
		59
	],
	"./app/AppSidebar.vue": [
		59
	],
	"./app/AppSidemenu": [
		45
	],
	"./app/AppSidemenu.vue": [
		45
	],
	"./app/CardListItem": [
		143,
		44
	],
	"./app/CardListItem.vue": [
		143,
		44
	],
	"./app/FAB": [
		138,
		38
	],
	"./app/FAB.vue": [
		138,
		38
	],
	"./app/PostList": [
		144,
		13
	],
	"./app/PostList.vue": [
		144,
		13
	],
	"./app/SelectComponent": [
		137,
		12
	],
	"./app/SelectComponent.vue": [
		137,
		12
	],
	"./app/SelectImage": [
		135,
		43
	],
	"./app/SelectImage.vue": [
		135,
		43
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1": [
		145,
		36
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1.l.scss": [
		346,
		151
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1.m.scss": [
		347,
		150
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1.s.scss": [
		348,
		149
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1.scss": [
		349,
		148
	],
	"./contents/AnchorLinkButtons1/AnchorLinkButtons1.vue": [
		145,
		36
	],
	"./contents/Card1/Card1": [
		146,
		22
	],
	"./contents/Card1/Card1.l.scss": [
		350,
		147
	],
	"./contents/Card1/Card1.m.scss": [
		351,
		146
	],
	"./contents/Card1/Card1.s.scss": [
		352,
		145
	],
	"./contents/Card1/Card1.scss": [
		353,
		144
	],
	"./contents/Card1/Card1.vue": [
		146,
		22
	],
	"./contents/CarouselStandard1/CarouselStandard1": [
		147,
		16
	],
	"./contents/CarouselStandard1/CarouselStandard1.l.scss": [
		354,
		143
	],
	"./contents/CarouselStandard1/CarouselStandard1.m.scss": [
		355,
		142
	],
	"./contents/CarouselStandard1/CarouselStandard1.s.scss": [
		356,
		141
	],
	"./contents/CarouselStandard1/CarouselStandard1.scss": [
		357,
		140
	],
	"./contents/CarouselStandard1/CarouselStandard1.vue": [
		147,
		16
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving": [
		148,
		26
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.l.scss": [
		358,
		139
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.m.scss": [
		359,
		138
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.s.scss": [
		360,
		137
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.scss": [
		361,
		136
	],
	"./contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.vue": [
		148,
		26
	],
	"./contents/GoogleMap1/GoogleMap1": [
		149,
		28
	],
	"./contents/GoogleMap1/GoogleMap1.l.scss": [
		362,
		135
	],
	"./contents/GoogleMap1/GoogleMap1.m.scss": [
		363,
		134
	],
	"./contents/GoogleMap1/GoogleMap1.s.scss": [
		364,
		133
	],
	"./contents/GoogleMap1/GoogleMap1.scss": [
		365,
		132
	],
	"./contents/GoogleMap1/GoogleMap1.vue": [
		149,
		28
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1": [
		150,
		24
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1.l.scss": [
		366,
		131
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1.m.scss": [
		367,
		130
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1.s.scss": [
		368,
		129
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1.scss": [
		369,
		128
	],
	"./contents/GridRichTextEditor1/GridRichTextEditor1.vue": [
		150,
		24
	],
	"./contents/GridRichTextEditor1/_.quill.snow.org.css": [
		370,
		51
	],
	"./contents/GridRichTextEditor1/quill.snow.import.scss": [
		371,
		127
	],
	"./contents/GridRichTextEditor1/quill.snow.scss": [
		372,
		126
	],
	"./contents/Iframe1/Iframe1": [
		151,
		27
	],
	"./contents/Iframe1/Iframe1.l.scss": [
		373,
		125
	],
	"./contents/Iframe1/Iframe1.m.scss": [
		374,
		124
	],
	"./contents/Iframe1/Iframe1.s.scss": [
		375,
		123
	],
	"./contents/Iframe1/Iframe1.scss": [
		376,
		122
	],
	"./contents/Iframe1/Iframe1.vue": [
		151,
		27
	],
	"./contents/LinkButtons1/LinkButtons1": [
		152,
		35
	],
	"./contents/LinkButtons1/LinkButtons1.l.scss": [
		377,
		121
	],
	"./contents/LinkButtons1/LinkButtons1.m.scss": [
		378,
		120
	],
	"./contents/LinkButtons1/LinkButtons1.s.scss": [
		379,
		119
	],
	"./contents/LinkButtons1/LinkButtons1.scss": [
		380,
		118
	],
	"./contents/LinkButtons1/LinkButtons1.vue": [
		152,
		35
	],
	"./contents/LinkButtons2/LinkButtons2": [
		153,
		34
	],
	"./contents/LinkButtons2/LinkButtons2.l.scss": [
		381,
		117
	],
	"./contents/LinkButtons2/LinkButtons2.m.scss": [
		382,
		116
	],
	"./contents/LinkButtons2/LinkButtons2.s.scss": [
		383,
		115
	],
	"./contents/LinkButtons2/LinkButtons2.scss": [
		384,
		114
	],
	"./contents/LinkButtons2/LinkButtons2.vue": [
		153,
		34
	],
	"./contents/MailContactImage1/MailContactImage1": [
		154,
		21
	],
	"./contents/MailContactImage1/MailContactImage1.l.scss": [
		385,
		113
	],
	"./contents/MailContactImage1/MailContactImage1.m.scss": [
		386,
		112
	],
	"./contents/MailContactImage1/MailContactImage1.s.scss": [
		387,
		111
	],
	"./contents/MailContactImage1/MailContactImage1.scss": [
		388,
		110
	],
	"./contents/MailContactImage1/MailContactImage1.vue": [
		154,
		21
	],
	"./contents/PostList1/PostList1": [
		155,
		11
	],
	"./contents/PostList1/PostList1.l.scss": [
		389,
		109
	],
	"./contents/PostList1/PostList1.m.scss": [
		390,
		108
	],
	"./contents/PostList1/PostList1.s.scss": [
		391,
		107
	],
	"./contents/PostList1/PostList1.scss": [
		392,
		106
	],
	"./contents/PostList1/PostList1.vue": [
		155,
		11
	],
	"./contents/RichTextEditor1/RichTextEditor1": [
		156,
		23
	],
	"./contents/RichTextEditor1/RichTextEditor1.l.scss": [
		393,
		105
	],
	"./contents/RichTextEditor1/RichTextEditor1.m.scss": [
		394,
		104
	],
	"./contents/RichTextEditor1/RichTextEditor1.s.scss": [
		395,
		103
	],
	"./contents/RichTextEditor1/RichTextEditor1.scss": [
		396,
		102
	],
	"./contents/RichTextEditor1/RichTextEditor1.vue": [
		156,
		23
	],
	"./contents/RichTextEditor1/_.quill.snow.org.css": [
		397,
		50
	],
	"./contents/RichTextEditor1/quill.snow.import.scss": [
		398,
		101
	],
	"./contents/RichTextEditor1/quill.snow.scss": [
		399,
		100
	],
	"./contents/SlideImage1/SlideImage1": [
		157,
		20
	],
	"./contents/SlideImage1/SlideImage1.l.scss": [
		400,
		99
	],
	"./contents/SlideImage1/SlideImage1.m.scss": [
		401,
		98
	],
	"./contents/SlideImage1/SlideImage1.s.scss": [
		402,
		97
	],
	"./contents/SlideImage1/SlideImage1.scss": [
		403,
		96
	],
	"./contents/SlideImage1/SlideImage1.vue": [
		157,
		20
	],
	"./contents/SlideImage2/SlideImage2": [
		158,
		19
	],
	"./contents/SlideImage2/SlideImage2.l.scss": [
		404,
		95
	],
	"./contents/SlideImage2/SlideImage2.m.scss": [
		405,
		94
	],
	"./contents/SlideImage2/SlideImage2.s.scss": [
		406,
		93
	],
	"./contents/SlideImage2/SlideImage2.scss": [
		407,
		92
	],
	"./contents/SlideImage2/SlideImage2.vue": [
		158,
		19
	],
	"./contents/SlideImages1/SlideImages1": [
		159,
		18
	],
	"./contents/SlideImages1/SlideImages1.l.scss": [
		408,
		91
	],
	"./contents/SlideImages1/SlideImages1.m.scss": [
		409,
		90
	],
	"./contents/SlideImages1/SlideImages1.s.scss": [
		410,
		89
	],
	"./contents/SlideImages1/SlideImages1.scss": [
		411,
		88
	],
	"./contents/SlideImages1/SlideImages1.vue": [
		159,
		18
	],
	"./contents/SlideWithImage/SlideWithImage": [
		160,
		17
	],
	"./contents/SlideWithImage/SlideWithImage.l.scss": [
		412,
		87
	],
	"./contents/SlideWithImage/SlideWithImage.m.scss": [
		413,
		86
	],
	"./contents/SlideWithImage/SlideWithImage.s.scss": [
		414,
		85
	],
	"./contents/SlideWithImage/SlideWithImage.scss": [
		415,
		84
	],
	"./contents/SlideWithImage/SlideWithImage.vue": [
		160,
		17
	],
	"./contents/SlideWithText1/SlideWithText1": [
		161,
		33
	],
	"./contents/SlideWithText1/SlideWithText1.l.scss": [
		416,
		83
	],
	"./contents/SlideWithText1/SlideWithText1.m.scss": [
		417,
		82
	],
	"./contents/SlideWithText1/SlideWithText1.s.scss": [
		418,
		81
	],
	"./contents/SlideWithText1/SlideWithText1.scss": [
		419,
		80
	],
	"./contents/SlideWithText1/SlideWithText1.vue": [
		161,
		33
	],
	"./contents/Table1/Table1": [
		162,
		32
	],
	"./contents/Table1/Table1.l.scss": [
		420,
		79
	],
	"./contents/Table1/Table1.m.scss": [
		421,
		78
	],
	"./contents/Table1/Table1.s.scss": [
		422,
		77
	],
	"./contents/Table1/Table1.scss": [
		423,
		76
	],
	"./contents/Table1/Table1.vue": [
		162,
		32
	],
	"./contents/Table2/Table2": [
		163,
		31
	],
	"./contents/Table2/Table2.l.scss": [
		424,
		75
	],
	"./contents/Table2/Table2.m.scss": [
		425,
		74
	],
	"./contents/Table2/Table2.s.scss": [
		426,
		73
	],
	"./contents/Table2/Table2.scss": [
		427,
		72
	],
	"./contents/Table2/Table2.vue": [
		163,
		31
	],
	"./contents/Table3/Table3": [
		164,
		30
	],
	"./contents/Table3/Table3.l.scss": [
		428,
		71
	],
	"./contents/Table3/Table3.m.scss": [
		429,
		70
	],
	"./contents/Table3/Table3.s.scss": [
		430,
		69
	],
	"./contents/Table3/Table3.scss": [
		431,
		68
	],
	"./contents/Table3/Table3.vue": [
		164,
		30
	],
	"./contents/Youtube1/Youtube1": [
		165,
		29
	],
	"./contents/Youtube1/Youtube1.l.scss": [
		432,
		67
	],
	"./contents/Youtube1/Youtube1.m.scss": [
		433,
		66
	],
	"./contents/Youtube1/Youtube1.s.scss": [
		434,
		65
	],
	"./contents/Youtube1/Youtube1.scss": [
		435,
		64
	],
	"./contents/Youtube1/Youtube1.vue": [
		165,
		29
	],
	"./footer/FooterCompany1/FooterCompany1": [
		166,
		14
	],
	"./footer/FooterCompany1/FooterCompany1.l.scss": [
		436,
		63
	],
	"./footer/FooterCompany1/FooterCompany1.m.scss": [
		437,
		62
	],
	"./footer/FooterCompany1/FooterCompany1.s.scss": [
		438,
		61
	],
	"./footer/FooterCompany1/FooterCompany1.scss": [
		439,
		60
	],
	"./footer/FooterCompany1/FooterCompany1.vue": [
		166,
		14
	],
	"./forms/ComponentFormFooter": [
		131,
		42
	],
	"./forms/ComponentFormFooter.vue": [
		131,
		42
	],
	"./forms/SelectLinks": [
		136,
		41
	],
	"./forms/SelectLinks.vue": [
		136,
		41
	],
	"./mimic-amp/MimicAmpCarousel": [
		139,
		37
	],
	"./mimic-amp/MimicAmpCarousel.vue": [
		139,
		37
	],
	"./mimic-amp/MimicAmpImg": [
		133,
		40
	],
	"./mimic-amp/MimicAmpImg.vue": [
		133,
		40
	],
	"./mimic-amp/MimicAmpSidebar": [
		32
	],
	"./mimic-amp/MimicAmpSidebar.vue": [
		32
	],
	"./mixins/ComponentBase": [
		132,
		39
	],
	"./mixins/ComponentBase.js": [
		132,
		39
	],
	"./mixins/RouteBase": [
		134,
		46
	],
	"./mixins/RouteBase.js": [
		134,
		46
	],
	"./navigation/NavigationStandard1/NavigationStandard1": [
		167,
		15
	],
	"./navigation/NavigationStandard1/NavigationStandard1.l.scss": [
		440,
		59
	],
	"./navigation/NavigationStandard1/NavigationStandard1.m.scss": [
		441,
		58
	],
	"./navigation/NavigationStandard1/NavigationStandard1.s.scss": [
		442,
		57
	],
	"./navigation/NavigationStandard1/NavigationStandard1.scss": [
		443,
		56
	],
	"./navigation/NavigationStandard1/NavigationStandard1.vue": [
		167,
		15
	],
	"./routes/Admin": [
		72,
		8
	],
	"./routes/Admin.vue": [
		72,
		8
	],
	"./routes/Error404": [
		73,
		10
	],
	"./routes/Error404.vue": [
		73,
		10
	],
	"./routes/Home": [
		74,
		5
	],
	"./routes/Home.vue": [
		74,
		5
	],
	"./routes/Login": [
		41
	],
	"./routes/Login.vue": [
		41
	],
	"./routes/Media": [
		75,
		7
	],
	"./routes/Media.vue": [
		75,
		7
	],
	"./routes/MediaUpload": [
		76,
		9
	],
	"./routes/MediaUpload.vue": [
		76,
		9
	],
	"./routes/Page": [
		77,
		1
	],
	"./routes/Page.vue": [
		77,
		1
	],
	"./routes/Pages": [
		78,
		4
	],
	"./routes/Pages.vue": [
		78,
		4
	],
	"./routes/Post": [
		79,
		0
	],
	"./routes/Post.vue": [
		79,
		0
	],
	"./routes/Posts": [
		80,
		2
	],
	"./routes/Posts.vue": [
		80,
		2
	],
	"./routes/Settings": [
		81,
		6
	],
	"./routes/Settings.vue": [
		81,
		6
	],
	"./routes/Themes": [
		82,
		3
	],
	"./routes/Themes.vue": [
		82,
		3
	],
	"./routes/home-instruction.md": [
		344,
		49
	],
	"./routes/home-sidemenus.md": [
		345,
		48
	],
	"./routes/home-updates.md": [
		343,
		47
	],
	"./sidebar/SidebarStandard1/SidebarStandard1": [
		168,
		25
	],
	"./sidebar/SidebarStandard1/SidebarStandard1.l.scss": [
		444,
		55
	],
	"./sidebar/SidebarStandard1/SidebarStandard1.m.scss": [
		445,
		54
	],
	"./sidebar/SidebarStandard1/SidebarStandard1.s.scss": [
		446,
		53
	],
	"./sidebar/SidebarStandard1/SidebarStandard1.scss": [
		447,
		52
	],
	"./sidebar/SidebarStandard1/SidebarStandard1.vue": [
		168,
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 340;
module.exports = webpackAsyncContext;

/***/ })
],[169]);


// WEBPACK FOOTER //
// static/js/app.0aa5ae8fe49113542f02.js